"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUf = void 0;
const helpers_1 = require("../helpers");
const getUf = (reseller) => {
    const isEudora = helpers_1.envConfig.currentBrand === 'EUD';
    const defaultUf = isEudora ? 'MA' : 'PR';
    const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
    const stateFromQuery = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('state');
    const regionFromQuery = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('region');
    return stateFromQuery || regionFromQuery || (reseller === null || reseller === void 0 ? void 0 : reseller.addressHomeState) || defaultUf;
};
exports.getUf = getUf;
